export default __webpack_public_path__ + "static/media/Waqas-Nasir.95a2a94c.pdf";